import * as React from 'react';
import { PriceInformation } from '../prices/PriceInformation';
export const LeasingWithoutFinancing = ({ fullVehicle, trackLayerLinkClick, configureFinanceComponents, }) => {
    return (React.createElement(PriceInformation, { vehicle: fullVehicle.basic, fullVehicle: fullVehicle, loanTypeLink: {}, trackLayerLinkClick: trackLayerLinkClick, configureFinanceComponents: configureFinanceComponents }));
};
